import Images from "../components/Images";
// import Image1 from "../images/Box1.png";
import Image1 from "../images/Image1.png"
import Image2 from "../images/Image2.png"
import Image3 from "../images/Image3.png"

export default function RoadTransport(){

    const data1 = {
        title: "Μέση Ταχύτητα ΙΧ αυτοκινήτων",
        type: "70 km/h",
        image1 : Image1,
    }

    const data2 = {
        title: "Συνολικές οχηματοώρες",
        type: "570.000",
        image1 : Image2,
    }

    const data3 = {
        title: "Συνολικά διανυθέντα οχηματοχιλιόμετρα",
        type: "40.000.000",
        image1 : Image3,
    }
    // Other data

    return(
        <div style = {{backgroundColor: "#F9FAFB", padding: "8%"}}>
            <h1 style = {{marginBottom: "10%"}}>Οι οδικές μεταφορές στη χώρα με αριθμούς</h1>

            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div>
                            <Images props = {data1}></Images>
                        
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <Images props = {data2}></Images>
                    
                           
                    </div>
                </div>
                <div className="row" style = {{justifyContent: "center"}}>
                <div className="col-lg-6">
                    <Images props = {data3}></Images>
                </div>
                </div>
            </div>
        </div>
    )
}